import Cookies from 'js-cookie'
import initAccessibility from "../libs/accessibility";
import debounce from 'lodash/debounce';

export default {
  options: {
    headerNavSelector: '.header__nav',
    headerContainer: '.header',
  },
  init() {
    this.initSelect2();
    this.initMobileHeaderNav();
    this.initStickyHeader();
    this.initHeaderNavDropdown();
    this.initHeaderSearch();
    // this.initProductAccordion();
    // this.initProductShare();
    this.initLazyloadImages();
    this.initIframeResize();
    this.initBottombar();
    this.initStickyButtons();
    this.initStickyCta();
    this.initSwipers();
    this.initCheckoutOnMobile();

    initAccessibility();

    $(document).on('DOMNodeInserted', () => {
      this.initLazyloadImages();
      this.initStickyButtons();
      this.initCheckoutOnMobile();
    });
  },
  initSelect2() {
    let $select2 = $('[data-init="select2"]');

    if ($select2.length) {
      $select2.select2();
    }
  },
  initStickyHeader() {
    let $headerSelector = $(this.options.headerContainer);

    if ($headerSelector.length) {
      // Sticky Header
      new window.Waypoint.Sticky({
        element: $headerSelector[0],
        stuckClass: 'fixed',
      });
    }
  },
  initHeaderNavDropdown() {
    let $headerNavSelector = $(this.options.headerNavSelector);

    if ($(window).width() > 1024) {
      $headerNavSelector.find('> ul > li').hover(function () {
        if ($(this).find('.submenu').length) {
          if ($(this).find('.submenu').hasClass('opened')) {
            $(this).removeClass('opened');
            $(this).find('.submenu').removeClass('opened');
          } else {
            $headerNavSelector.find('.submenu').removeClass('opened');
            $headerNavSelector.find('> ul > li').removeClass('opened');
            $(this).addClass('opened');
            $(this).find('.submenu').addClass('opened');
          }
        }
      });
    } else {
      $headerNavSelector.find('> ul > li > a').click(function (e) {
        if ($(this).parent().find('.submenu').length) {
          e.preventDefault();

          if ($(this).parent().find('.submenu').hasClass('opened')) {
            $(this).parent().removeClass('opened');
            $(this).parent().find('.submenu').removeClass('opened');
          } else {
            $headerNavSelector.find('.submenu').removeClass('opened');
            $headerNavSelector.find('> ul > li').removeClass('opened');
            $(this).parent().addClass('opened');
            $(this).parent().find('.submenu').addClass('opened');
          }
        }
      });
    }

    if ($(window).width() > 992) {
      if ($headerNavSelector.length) {
        let $headerNavOffset = $headerNavSelector.position().top,
          $headerNavHeight = $headerNavSelector.innerHeight(),
          $headerElementsHeight = $headerNavOffset + $headerNavHeight + 1;

        $headerNavSelector.find('.submenu').css('top', $headerElementsHeight + 'px').css('max-height', 'calc(100vh + ' + $headerElementsHeight + 'px)');
      }
    }
  },
  initMobileHeaderNav() {
    let $headerNavSelector = $(this.options.headerNavSelector),
      $bodySelector = $('html, body'),
      $mobileHamburger = $headerNavSelector.find('.hamb');

    $mobileHamburger.click(function (e) {
      e.preventDefault();

      $(this).toggleClass('open');

      if ($headerNavSelector.hasClass('opened')) {
        $bodySelector.removeClass('mobile-menu-opened');
        $headerNavSelector.removeClass('opened');
        $('.submenu').removeClass('opened').fadeOut(300);
        $('li.has-dropdown').removeClass('opened');
        $mobileHamburger.attr('aria-expanded', 'false');
      } else {
        $bodySelector.addClass('mobile-menu-opened');
        $headerNavSelector.addClass('opened');
        $mobileHamburger.attr('aria-expanded', 'true');
        setTimeout(function () {
          const fstEl = $headerNavSelector.find('> ul > li.has-dropdown > a').first();
          fstEl.trigger('focus');
          fstEl.trigger('click');
        }, 400)
      }
    });

    $(window).resize(function () {
      $mobileHamburger.removeClass('open');
      $bodySelector.removeClass('mobile-menu-opened');
      $headerNavSelector.removeClass('opened');
      $('.submenu').removeClass('opened').fadeOut(300);
      $('li.has-dropdown').removeClass('opened');
    });
  },
  initHeaderSearch() {
    let $headerSearch = $('.header__search'),
      $openSearch = $headerSearch.find('.open_search'),
      $closeSearch = $headerSearch.find('.close_search'),
      $headerNavSelector = $(this.options.headerNavSelector),
      $headerInput = $('#headerSearch'),
      $headerLogoSelector = $('.header__logo');

    const onSearchInput = ev => {
      const event = new Event('app::auto-search')
      event.value = ev.target.value

      // Event will be readed by <header-auto-search> vue component
      document.dispatchEvent(event)
    }

    $headerInput.on('input', debounce(onSearchInput, 300))

    if ($headerSearch.length) {
      $openSearch.click(function () {
        $headerSearch.addClass('opened');
        $headerSearch.find('input').focus();
        $headerNavSelector.addClass('search_opened');
        $headerLogoSelector.addClass('search_opened');

        // Event will be readed by <header-auto-search> vue component
        document.dispatchEvent(new Event('app::auto-search-show'))
      });

      $closeSearch.click(function () {
        $headerSearch.removeClass('opened');
        $headerNavSelector.removeClass('search_opened');
        $headerLogoSelector.removeClass('search_opened');
        $openSearch.focus();
        // Event will be readed by <header-auto-search> vue component
        document.dispatchEvent(new Event('app::auto-search-close'))
      });

      $(document).click(function (event) {
        if (!$(event.target).closest('.header__search').length) {
          $headerSearch.removeClass('opened');
          $headerNavSelector.removeClass('search_opened');
          $headerLogoSelector.removeClass('search_opened');
          // Event will be readed by <header-auto-search> vue component
          document.dispatchEvent(new Event('app::auto-search-close'))
        }
      });
    }
  },
  initProductAccordion() {
    let $productListSelector = $('.product__description'),
      $itemLink = $productListSelector.find('.item > a');

    if ($productListSelector.length) {
      $itemLink.click(function (e) {
        e.preventDefault();
        $itemLink.not(this).parent().removeClass('opened');
        $itemLink.not(this).parent().find('.text').slideUp(300);
        if ($(this).parent().hasClass('opened')) {
          $(this).parent().removeClass('opened');
          $(this).parent().attr('aria-expanded', 'false');
          $(this).parent().find('.text').slideUp(300);
        } else {
          $(this).parent().addClass('opened');
          $(this).parent().attr('aria-expanded', 'true');
          $(this).parent().find('.text').slideDown(300);
        }
      });
    }
  },
  initProductShare() {
    let $productShare = $('.product__action .share'),
      $shareLink = $productShare.find('> a'),
      $shareList = $productShare.find('.share__list');

    if ($productShare.length) {
      $(document).on('click', $shareLink, function (e) {
        e.preventDefault();

        $productShare.toggleClass('opened');

        if ($shareList.hasClass('opened')) {
          $shareList.removeClass('opened');
          $shareList.fadeOut(300);
        } else {
          $shareList.addClass('opened');
          $shareList.fadeIn(300);
        }
      });

      $(document).click(function () {
        if (!$(event.target).closest('.product__action .share').length) {
          $productShare.removeClass('opened');
          $shareList.removeClass('opened');
          $shareList.fadeOut(300);
        }
      });
    }
  },
  initLazyloadImages() {
    let $lazyImagesSelector = $('.lazy[data-src]');

    if ($lazyImagesSelector.length) {
      $lazyImagesSelector.Lazy({
        threshold: 500,
      });
    }
  },
  initIframeResize() {
    let iframeElement = $('.text-block iframe');
    if (iframeElement.length) {
      iframeElement.iFrameResize([{autoResize: true}]);
    }
  },
  initBottombar() {
    let self = this;

    if (window.innerWidth < 768) {
      window.addEventListener('scroll', function () {
        self.showBottombar();
      });
    }
  },
  showBottombar: function () {
    let $bottombarSelector = document.querySelector('.bottombar, .mobile_bottombar'),
      $footerHeight = document.querySelector('.footer');

    if ($bottombarSelector) {
      // if (document.documentElement.scrollTop + window.innerHeight > (document.documentElement.offsetHeight - $footerHeight.offsetHeight)) {
      //     $bottombarSelector.classList.add('in-bottom');
      //     $bottombarSelector
      //       .querySelectorAll('input, button, a')
      //       .forEach(el => el.setAttribute('tabindex', -1));
      // } else {
      //     $bottombarSelector.classList.remove('in-bottom');
      //     $bottombarSelector
      //       .querySelectorAll('input, button, a')
      //       .forEach(el => el.removeAttribute('tabindex', -1));
      // }
    }
  },
  showCta: function () {
    let $bottombarSelector = document.querySelector('.sticky_cta'),
      $footerHeight = document.querySelector('.footer');

    if (!$bottombarSelector) {
      return;
    }

    if (document.documentElement.scrollTop + window.innerHeight > (document.documentElement.offsetHeight - $footerHeight.offsetHeight)) {
      $bottombarSelector.classList.add('in-bottom');
      $bottombarSelector
      .querySelectorAll('input, button, a')
      .forEach(el => el.setAttribute('tabindex', -1));
    } else {
      $bottombarSelector.classList.remove('in-bottom');
      $bottombarSelector
      .querySelectorAll('input, button, a')
      .forEach(el => el.removeAttribute('tabindex', -1));
    }
  },
  initSwipers() {
    new Swiper('.swiper-container', {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
      },
    })
  },
  initStickyCta() {
    let self = this;

    if (window.innerWidth > 767) {
      window.addEventListener('scroll', function () {
        self.showCta();
      });
    }

    const $container = $('.sticky_cta');
    const $closeButton = $container.find('> .close');

    if ($container.length && Cookies.get('hide_cta') === '1') {
      $container.hide();
    } else if ($container.length) {
      $container.show();
    }

    if ($closeButton.length) {
      $closeButton.on('click', function (event) {
        event.preventDefault();
        $container.hide();
        Cookies.set('hide_cta', '1', {expires: 1});
      });

      $closeButton.on('keydown', function (event) {
        if (event.key.toLowerCase() === "enter") {
          event.preventDefault();
          $container.hide();
          Cookies.set('hide_cta', '1', {expires: 1});
        }
      });
    }
  },
  initStickyButtons() {
    let $stickySelector = $('.sticky-block'),
      $headerSelector = $('.header'),
      $headerHeight = 0,
      $offset = 15;

    if ($headerSelector.length) {
      $headerHeight = $headerSelector.height()
    }

    if ($stickySelector.length) {
      $stickySelector.stick_in_parent({
        offset_top: $headerHeight + $offset,
        sticky_class: 'is_stuck',
        //recalc_every: 1,
        inner_scrolling: true,
        parent: '.sticky-parent',
      });

      if ($(window).width() < 992) {
        $stickySelector.trigger('sticky_kit:detach');
      }

      $(window).resize(function () {
        if ($(window).width() < 992) {
          $stickySelector.trigger('sticky_kit:detach');
        } else {
          $stickySelector.trigger('sticky_kit:recalc');
        }
      });
    }
  },
  initCheckoutOnMobile() {
    let $inputs = document.querySelectorAll('.checkout input'),
        $sticky_cta = document.querySelector('.sticky_cta'),
        $header = document.querySelector('.header');

    if (window.innerWidth < 768) {
      Array.prototype.forEach.call($inputs, function (el) {
        el.addEventListener('focusin', function() {
          if (document.body.contains($sticky_cta)) {
            $sticky_cta.style.display = 'none';
          }

          $header.style.transform = 'translateY(-120px)';
        });

        el.addEventListener('focusout', function() {
          if (document.body.contains($sticky_cta)) {
            $sticky_cta.style.display = 'block';
          }

          $header.style.transform = 'none';
        });
      });
    }
  },
};
